export const ADMIN_KEY = "admin";
export const PROFILE_KEY = "profile";
export const LOGOUT_KEY = "logout";
export const HELP_CENTRE_KEY = "help centre";
export const CLICK_PROFILE = "CLICK_DROPDOWN_PROFILE";
export const CLICK_DROPDOWN_USER_MG = "CLICK_DROPDOWN_USER_MG";
export const CLICK_DROPDOWN_HELPCENTER = "CLICK_DROPDOWN_HELPCENTER";
export const CLICK_DROPDOWN_LOGOUT = "CLICK_DROPDOWN_LOGOUT";
export const FORCE_LOGOUT = "FORCE_LOGOUT";
export const USER_INACTIVITY = "USER_INACTIVITY";
export const FINANCES_KEY = "finances";
export const INSIGHTS_KEY = "insights";
export const ORDER_KEY = "order";
export const FEEDBACK_KEY = "feedback";
export const MENU_KEY = "menu";
export const UMP_KEY = "ump";
export const MARKETING_KEY = "marketing";
export const INVENTORY_KEY = "inventory";
export const HOME_KEY = "dashboard";
export const PAYNOW_KEY = "paynow";
export const LANGUAGE_KEY = "language";
export const USER_GUIDE_KEY = "user-guide";
export const INTRO_TO_FEATURE_KEY = "intro-to-feature";
export const OBSERVER_KEY = "observer";
export const CRM_KEY = "crm";

//Custom Authz Roles and Resource Types
export const ROLE_AUTHZ = "authz";
export const ROLE_SUPER_ADMIN = "super_admin";
export const EMPLOYEE_MANAGEMENT = "employee_management";

// Troy Local Storage Key
export const TOGGLE_FEATURE = "__TOGGLE_FEATURE__";
export const EXPIRY_TIME = "_expiredTime";
export const DASHBOARD_ONBOARDED_LS = "isDashboardOnboarded";

export const hasAccessTroy = "hasAccessTroy";
export const hasAccessMenu = "hasAccessMenu";
export const hasAccessUMP = "hasAccessUMP";
export const hasBannerUpsell = "hasBannerUpsell";
export const hasBannerFreeCredit = "hasBannerFreeCredit";
export const hasBannerFreeAmount = "hasBannerFreeAmount";
export const hasAccessMarketing = "hasAccessMarketing";
export const hasUserGuide = "hasUserGuide";
export const hasAccessInventory = "hasAccessInventory";
export const hasMexPortalNavigationExperiment =
  "hasMexPortalNavigationExperiment";
export const hasAccessPayNow = "hasAccessPayNow";
export const hasAccessDashboard = "hasAccessDashboard";
export const hasAccessInsightsEnhancementsV2 =
  "hasAccessInsightsEnhancementsV2";
export const hasAccessOrderManager = "hasAccessOrderManager";
export const hasAccessFeedback = "hasAccessFeedback";
export const hasMultiEntityEnabled = "hasMultiEntityEnabled";
export const mexHasMmOrder = "mexHasMmOrder";
export const mexHasImOrder = "mexHasImOrder";
export const mexPortalUserPermissionSystem = "mexPortalUserPermissionSystem";
export const enableMFE = "mexPortalMFE";
export const enableMexPortalObserverMode = "enableMexPortalObserverMode";
export const enableMarketingForObserver = "enableMarketingForObserver";
export const hasAccessCRM = "enableCRM";
export const LS_IS_PAYNOW_QR_MODAL_ONBOARDED = "isPayNowQRModalOnboarded";

export const BUSINESS_LINE_IDS_LS = "businessLineIds";

// Troy Sidebar Menu
export const TROY_SIDE_BAR_NAVIGATION = "SIDE_BAR_NAVIGATION";
export const TROY_CLICK_INSIGHTS = "CLICK_INSIGHTS";
export const TROY_CLICK_FINANCE = "CLICK_FINANCE";
export const TROY_CLICK_EMPLOYEE = "CLICK_EMPLOYEE";
export const TROY_CLICK_PROFILE = "CLICK_PROFILE";
export const TROY_CLICK_HC = "CLICK_HC";
export const TROY_CLICK_LOGOUT = "CLICK_LOGOUT";
export const TROY_CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const TROY_CLICK_MENU = "CLICK_MENU";
export const TROY_CLICK_UMP = "CLICK_UMP";
export const TROY_CLICK_INVENTORY = "CLICK_INVENTORY";
export const TROY_CLICK_MARKETING = "CLICK_MARKETING";
export const TROY_CLICK_READ_GUIDE = "CLICK_READ_GUIDE";
export const TROY_GUIDE_SHOW_TOOLTIP = "SHOW_TOOLTIP";
export const TROY_GUIDE_CLICK_TOOLTIP = "CLICK_TOOLTIP_ACK";
export const TROY_CLICK_PAYNOW = "CLICK_PAYNOW";
export const TROY_CLICK_HOME = "CLICK_HOME";
export const TROY_CLICK_ORDER = "CLICK_ORDERS";
export const TROY_CLICK_FEEDBACK = "CLICK_FEEDBACK";
export const TROY_HOME_ONBOARDING = "HOME_ONBOARDING";
export const TROY_PAGEVIEW = "PAGEVIEW";
export const TROY_CLICK_CRM = "CLICK_CRM_TILE";

export const LS_IS_PAYNOW_QR_VISITED = "isPayNowQRVisited";

// Troy and Phoenix hostnames
export const TROY_LOCAL_HOSTNAME = "troy.test";
export const TROY_STAGE_HOSTNAME = "merchant.stg-myteksi.com";
export const TROY_PHOENIX_STAGE_HOSTNAME =
  "mex-ops-finance-phoenix.stg-grabpay.com";
export const GP_STAGE_HOSTNAME = "stg-merchantcentral.stg-grabpay.com";
export const VN_STAGE_HOSTNAME = "stg-merchant.moca.vn";
export const ID_STAGE_HOSTNAME = "stg-mmp-view01.aws.ovo.id";

// Merchant App Download Modal
export const STG_WEB_TO_APP_URL = "https://grab.onelink.me/k45t/4827191c";
export const PROD_WEB_TO_APP_URL = "https://grab.onelink.me/k45t/60533e97";

// Troy user role
export const ROLE_STORE_MANAGER = "Store Manager";
export const ROLE_OWNER = "Owner";
export const ROLE_CASHIER = "Cashier";

// Troy user profile status
export const PROFILE_STATUS_DRAFT = "DRAFT";

// Troy User Guide
export const userGuideEnglishVersion =
  "https://d3sv7vl0rhlxg2.cloudfront.net/user-guide/english-version.pdf";
export const userGuideMalayVersion =
  "https://d3sv7vl0rhlxg2.cloudfront.net/user-guide/malaysia-version.pdf";
export const userGuideThaiVersion =
  "https://d3sv7vl0rhlxg2.cloudfront.net/user-guide/thai-version.pdf";
export const userGuideVietnameseVersion =
  "https://d3sv7vl0rhlxg2.cloudfront.net/user-guide/vietnamese-version.pdf";
export const userGuideBahasaVersion =
  "https://d3sv7vl0rhlxg2.cloudfront.net/user-guide/bahasa-version.pdf";

// Help Center auth handover
export const HC_HANDOVER_READY = "HC_HANDOVER_READY";
export const SOURCE_HANDOVER_JWT = "SOURCE_HANDOVER_JWT";
export const HC_HANDOVER_COMPLETE = "HC_HANDOVER_COMPLETE";
export const HC_HANDOVER_START = "HC_HANDOVER_START";
export const HC_HANDOVER_SUCCESS = "HC_HANDOVER_SUCCESS";
export const HC_HANDOVER_FAILED = "HC_HANDOVER_FAILED";

export const ID = "ID";
export const MY = "MY";
export const PH = "PH";
export const SG = "SG";
export const TH = "TH";
export const VN = "VN";
export const MM = "MM";
export const KH = "KH";

export const COUNTRY_STRING_MAP = {
  ID: "Indonesia",
  MY: "Malaysia",
  PH: "Philippines",
  SG: "Singapore",
  TH: "Thailand",
  VN: "Vietnam",
  MM: "Myanmar",
};

export const LANGUAGE_OPTIONS = {
  GB: {
    code: "En",
    text: "troyCommon-navigation-001-010",
  },
  EN: {
    code: "En",
    text: "troyCommon-navigation-001-010",
  },
  ID: {
    code: "Id",
    text: "troyCommon-navigation-001-011",
  },
  VN: {
    code: "Vn",
    text: "troyCommon-navigation-001-014",
  },
  CN: {
    code: "Cn",
    text: "troyCommon-navigation-001-013",
  },
  TH: {
    code: "Th",
    text: "troyCommon-navigation-001-015",
  },
  MY: {
    code: "My",
    text: "troyCommon-navigation-001-012",
  },
};

export const MODAL_TYPE_DOWNLOAD_APP = "modal-download-app";
export const MODAL_TYPE_LANGUAGE_SELECTION = "modal-language-select";
export const MODAL_TYPE_ONBOARDING = "modal-onboarding";
export const MODAL_TYPE_FEATURE_FLAG = "modal-feature-flag";
export const MULTI_ENTITY_PLATFORM = "MULTI_ENTITY";
export const UNVERIFIED_MERCHANT_PLATFORM = "UNVERIFIED_MERCHANT";

export const moca = "moca";
export const grabpay = "grabpay";
export const ovo = "ovo";
export const GP = "GP";
export const GF = "GF";
export const GM = "GM";